var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"logoURL",style:(_vm.imgStyle),attrs:{"src":_vm.imageUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }